import * as React from "react";

import { Apps28Filled, Apps28Regular } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";

const AgencyHubApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "AgencyHub" */ "./AgencyHubApp");
    return { default: namedExport.AgencyHubApp };
});

export const AgencyHub: TeamAppConfig = {
    title: "Agency Hub",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "Agency Hub - Lightweight AI Chat with Plugin Selection",
    team: "OpsGenie",
    publicId: "ExchangeOSP",
    owner: "OpsGenieFeedback@microsoft.com",
    role: "*",
    tags: [],
    app: AgencyHubApp,
    path: "/AgencyHub"
};
